type InterrupterInfo = {
  id: string;
  title: string;
  description: string;
  tags?: never;
};

type InterrupterInfoWithTags = {
  id: string;
  title: string;
  description?: never;
  tags: {
    id: string;
    label: string;
  }[];
};

export type InterrupterData = InterrupterInfo | InterrupterInfoWithTags;

export const interrupterCards: InterrupterData[] = [
  {
    id: 'interrupter-tags',
    title: 'DREAM_MACHINE_INTERRUPTER_CARD_TITLE_1',
    tags: [
      {
        id: 'tag-1',
        label: 'DREAM_MACHINE_INTERRUPTER_CARD_TAG_1',
      },
      {
        id: 'tag-2',
        label: 'DREAM_MACHINE_INTERRUPTER_CARD_TAG_2',
      },
      {
        id: 'tag-3',
        label: 'DREAM_MACHINE_INTERRUPTER_CARD_TAG_3',
      },
    ],
  },
  {
    id: 'interrupter-2',
    title: 'DREAM_MACHINE_INTERRUPTER_CARD_TITLE_2',
    description: 'DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_2',
  },
  {
    id: 'interrupter-3',
    title: 'DREAM_MACHINE_INTERRUPTER_CARD_TITLE_3',
    description: 'DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_3',
  },
  {
    id: 'interrupter-4',
    title: 'DREAM_MACHINE_INTERRUPTER_CARD_TITLE_4',
    description: 'DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_4',
  },
  {
    id: 'interrupter-5',
    title: 'DREAM_MACHINE_INTERRUPTER_CARD_TITLE_5',
    description: 'DREAM_MACHINE_INTERRUPTER_CARD_DESCRIPTION_5',
  },
];
